import React from "react";
import { Box, Tag } from "@chakra-ui/react";

const BANK_STATUS_CONFIG = {
    draft:           { label: "En attente certification",  color: "#ff9800", bg: "rgba(255, 152, 0, 0.15)", border: "rgba(255, 152, 0, 0.4)" },
    pending_connect: { label: "Activation Stripe en cours", color: "#29b6f6", bg: "rgba(33, 150, 243, 0.15)", border: "rgba(33, 150, 243, 0.4)" },
    active:          { label: "Compte actif",               color: "#4caf50", bg: "rgba(76, 175, 80, 0.15)", border: "rgba(76, 175, 80, 0.4)" },
    failed:          { label: "Activation échouée",         color: "#ef5350", bg: "rgba(244, 67, 54, 0.15)", border: "rgba(244, 67, 54, 0.4)" }
};

/**
 * Returns Chakra style props for the banking status tag.
 * @param {{color:string,bg:string,border:string}} cfg
 * @param {boolean} isMobile
 * @returns {Object}
 */
function statusChipSx(cfg, isMobile) {
    return {
        background: cfg.bg,
        color: cfg.color,
        border: `1px solid ${cfg.border}`,
        fontWeight: 600,
        fontSize: isMobile ? "0.7rem" : "0.75rem",
        height: "24px",
        borderRadius: "8px"
    };
}

/**
 * Returns Chakra style props for the failed-status admin_message alert.
 * @param {boolean} isMobile
 * @returns {Object}
 */
function statusAlertSx(isMobile) {
    return {
        mt: 3,
        padding: "8px 12px",
        background: "rgba(244, 67, 54, 0.08)",
        color: "rgba(255, 255, 255, 0.85)",
        border: "1px solid rgba(244, 67, 54, 0.25)",
        borderRadius: "8px",
        fontSize: isMobile ? "0.75rem" : "0.8rem"
    };
}

/**
 * Renders the banking activation status badge and an error alert when failed.
 * @param {Object} props
 * @param {string} [props.status] - One of 'draft' | 'pending_connect' | 'active' | 'failed'
 * @param {string|null} [props.adminMessage] - Stripe rejection reason when status === 'failed'
 * @param {boolean} props.isMobile - Mobile viewport flag
 * @returns {React.ReactElement|null}
 */
function BankStatusBanner({ status, adminMessage, isMobile }) {
    const cfg = BANK_STATUS_CONFIG[status];
    if (!cfg) return null;
    return (
        <Box mb={4}>
            <Tag size="sm" {...statusChipSx(cfg, isMobile)}>{cfg.label}</Tag>
            {status === "failed" && adminMessage && (
                <Box {...statusAlertSx(isMobile)}>
                    {adminMessage}
                </Box>
            )}
        </Box>
    );
}

export default BankStatusBanner;
